import { render, staticRenderFns } from "./CompaniesSwitcher.vue?vue&type=template&id=0770ae16&scoped=true"
import script from "./CompaniesSwitcher.vue?vue&type=script&lang=ts"
export * from "./CompaniesSwitcher.vue?vue&type=script&lang=ts"
import style0 from "./CompaniesSwitcher.vue?vue&type=style&index=0&id=0770ae16&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0770ae16",
  null
  
)

export default component.exports